import React from 'react';
import { Box, Typography } from '@mui/material';

// ─── PlatformFooter ─────────────────────────────────────────────────────────
// Pie de página con el logo de la plataforma (public/logodp.png) y el link
// a emojisurveys.pro. Extraído de SurveyResponse.jsx como componente propio
// para mantener el JSX principal más liviano. Estilos vía `sx` (sin CSS
// separado).
const PlatformFooter = ({ t }) => {
  return (
    <Box
      sx={{
        display:        'flex',
        flexDirection:  'row',
        alignItems:     'center',
        justifyContent: 'center',
        gap:             { xs: 0.75, sm: 1 },
        textAlign:      'center',
        pt:              { xs: 2.5, sm: 3 },
        pb:              { xs: 3, sm: 4 },
        mt:              2,
        borderTop:      '1px solid rgba(0, 0, 0, 0.08)',
      }}
    >
      <Box
        component="img"
        src="/logo26.png"
        alt="EmojiSurveys"
        sx={{
          height:     { xs: 24, sm: 32, md: 38 },
          width:      'auto',
          objectFit:  'contain',
          opacity:    0.85,
        }}
      />

      <Typography
        variant="caption"
        sx={{
          color:           'rgba(0, 0, 0, 0.5)',
          fontSize:        { xs: '0.7rem', sm: '0.875rem' },
          letterSpacing:   '0.3px',
          display:         'flex',
          alignItems:      'center',
          justifyContent:  'center',
          gap:             0.5,
        }}
      >
        {t.poweredBy}{' '}
        <Box
          component="a"
          href="https://emojisurveys.pro"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color:           'primary.main',
            fontWeight:      600,
            textDecoration:  'none',
            position:        'relative',
            transition:      'color 0.3s ease',
            '&:hover': {
              color: 'primary.dark',
            },
            '&::after': {
              content:          '""',
              position:         'absolute',
              width:            0,
              height:           '2px',
              bottom:           -2,
              left:             0,
              backgroundColor:  'primary.dark',
              transition:       'width 0.3s ease',
            },
            '&:hover::after': {
              width: '100%',
            },
          }}
        >
          emojisurveys.pro
        </Box>
      </Typography>
    </Box>
  );
};

export default PlatformFooter;